import { Group, GroupProps } from '@mantine/core'
import cn from 'classnames'

import styles from './DashboardCardGroup.module.css'

export function DashboardCardGroup({ className, ...props }: GroupProps) {
  return <Group className={cn(styles.group, className)} {...props} />
}
